<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
            <div class="mobile_head_operate" >
<!--                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">-->
<!--                    <ul class="head_operate_popover_list">-->
<!--                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">-->
<!--                            <i :class="item.icon"></i> <span v-text="item.text"></span>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                    <template #reference>-->
<!--                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>-->
<!--                    </template>-->
<!--                </van-popover>-->
            </div>
        </div>
        <div class="warehouse_add_container mobile_container">
            <div class="warehouse_add_wrap">
                <div class="field_item">
                    <div class="field_content">
                        <van-field @click="handleClickSelectStock()" required clickable is-link label="转入仓库" :value="formData.in_stock_name"  name="in_stock_id" placeholder="请输入或选择仓库名称"  readonly></van-field>
                    </div>
                </div>
                <div class="product_list">
                    <ul>
                        <li v-for="(item,index) in formData.productData" :key="index">
                            <div class="product_field product_border flex_js_wrap">
                                <template v-if="item.is_edit">
                                    <van-popover :get-container="getContainer" v-model="item.productPopoverShow"  style="left: 0 !important;" :show-arrow="false" :offset="[0,0]" trigger="click" placement="bottom-start">
                                        <div class="productItemBox" v-if="productList.length>0">
                                            <div class="product_item flex_js_wrap" v-for="list in productList" @click="handleClickSelectProduct(list,item)">
                                                <div class="product_name ellipsis">{{ list.name }}</div>
                                            </div>
                                        </div>
                                        <template #reference>
                                            <van-field v-model="item.name" @input="handleInputProduct(item)" @blur="handleBlurProduct(item)" label="" placeholder="请输入产品名称" ></van-field>
                                        </template>
                                    </van-popover>
                                    <span>
                                        <span class="field_button"  @click="handleClickSelectPopupProduct(item,index)">选择</span>
                                    </span>
                                </template>
                                <template v-else>
                                    <van-field v-model="item.name" label="" placeholder="请输入产品名称" readonly></van-field>
                                </template>

                            </div>

                            <div class="product_field product_border">
                                <van-field v-model="item.stock_info.total_num" type="number" label="库存数量" readonly  placeholder="系统带出"></van-field>
                            </div>
                            <div class="product_field ">
                                <div class="bt required">入库数量/产品编码</div>
                                <div class="select_number flex_js_wrap">
                                    <van-field v-model="item.no_code_num" @blur="handleInputNoCodeNum(item)" type="digit" label="" placeholder="请输入数量"></van-field>
                                    <div class="select_code_box flex_js_wrap">
                                       <span>
                                            <span class="line"></span>
                                            <span class="select_btn" @click="handleClickSelectCode(item)">选择编码</span>
                                       </span>
                                        <span class="total_num">共{{item.total_num}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <div class="product_add">
                        <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增组</span>
                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="formData.note"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
        <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :selectedStockId="formData.in_stock_id ? formData.in_stock_id : 0" :disabledStockId="warehouseId" @success="selectStockSuccess"/>
        <SelectCode  :selectCodePopupShow.sync="selectCodePopupShow" v-if="selectCodePopupShow"  :selectedCodeData="selectedCodeData" :productInfo="productInfo" @success="selectCodeOneSuccess" />
        <SelectProductTransfer :selectProductTransferPopupShow.sync="selectProductTransferPopupShow" v-if="selectProductTransferPopupShow" :stockId="warehouseId" :selectData="formData.productData"  @success="selectProductSuccess"/>

    </div>
</template>

<script>
import {mapState} from "vuex";
import { Dialog } from "vant";
import {stockTransfer,stockList,searchOutProducts,chooseCode} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import SelectStock from "../component/select_stock"
import SelectCode from "../component/select_code"
import SelectProductTransfer from "../component/select_product_transfer"
import {removeTag} from "@/utils"
import {EventBus} from '@/utils/eventBus';
export default {
    name: "productTransfer",
    components: {ReturnNavBar,SelectStock,SelectCode,SelectProductTransfer},
    data() {
        return {
            warehouseId:0,
            formData:{
                in_stock_id: "",
                in_stock_name: "",
                note:"",
                productData:[
                    {
                        stock_id:'',
                        sku_id:'',
                        sku_key:'',
                        name:'',
                        unit:'',
                        stock_info:{
                            code_num:0,
                            no_code_num:0,
                            total_num:0
                        },
                        code_num:0,
                        no_code_num:0,
                        total_num:0,
                        code_list:[],
                        is_edit:true
                    }
                ]
            },
            btnDisabled:false,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"codeIdentification", text: "粘贴编码识别", icon: "iconfont icon-chuku" },
            ],
            value:'',
            productPopoverShow:false,
            productList:[],
            selectStockPopupShow:false,
            productInfo:null,
            productIndex:null,
            codeIdentificationPopupShow:false,
            selectedCodeData:[],//已选编码
            selectCodePopupShow:false,
            selectProductTransferPopupShow:false,
        };
    },
    computed: {
        ...mapState(['inventoryProductData']),
    },
    created() {
        this.warehouseId = Number(this.$route.query.warehouse_id)
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.formData.productData = this.inventoryProductData.map((item)=>{
                return {
                    stock_id:this.warehouseId,
                    sku_id:item.sku_id,
                    sku_key:item.sku_key,
                    name:item.name,
                    unit:item.unit,
                    stock_info:{
                        code_num:item.code_num,
                        no_code_num:item.no_code_num,
                        total_num:item.total_num,
                    },
                    code_num:0,
                    no_code_num:0,
                    total_num:0,
                    code_list:[],
                }
            })
        }else if(this.formData.productData.length == 1){
            this.formData.productData[0].stock_id = this.warehouseId
        }
        this.getSearchProducts({name:''})
    },
    methods: {
        // 自定义返回
        handleClickReturnRouter() {
            if(JSON.stringify(this.formData) != JSON.parse(JSON.stringify(this.$options.data().formData))){
                Dialog.confirm({
                    title: "取消编辑",
                    message: "是否要取消编辑，取消后编辑内容不保留，是否取消",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                })
                .then(() => {
                    this.$store.dispatch("inventoryProductData", []);
                    removeTag(this.$route)
                    this.$router.go(-1);
                })
                .catch(() => { });
            }else{
                this.$store.dispatch("inventoryProductData", []);
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        getContainer() {
            return  document.querySelector('.warehouse_add_container')
        },
        // 获取产品
        getSearchProducts(item){
            searchOutProducts({
                keyword:item.name,
                stock_id:this.warehouseId
            }).then(res => {
                if (res.code === 200) {
                    this.productList = res.data ? res.data : []
                    if(item.name){
                        this.$set(item,'productPopoverShow',true)
                    }
                }
            })
        },
        // 输入时
        handleInputProduct(item){
            this.getSearchProducts(item)
        },
        // 输入产品失去焦点
        handleBlurProduct(item){
            let info = this.productList.find(find => find.name == item.name)
            if(!info){
                this.$set(item,'name','')
                this.$set(item,'sku_id','')
                this.$set(item,'sku_key','')
                this.$set(item,'unit','个')
                this.$set(item,'stock_info',{
                    code_num:0,
                    no_code_num:0,
                    total_num:0
                })
                this.$set(item,'code_num',0)
                this.$set(item,'no_code_num',0)
                this.$set(item,'total_num',0)
            }else{
                this.handleClickSelectProduct(info,item)
            }
        },
        // 选中产品
        handleClickSelectProduct(info,item){
            if(this.formData.productData.filter(find=> find.name == info.name).length>0){
                this.$toast(`${info.name}已存在`)
                this.$set(item,'name','')
                return false
            }
            this.$set(item,'name',info.name)
            this.$set(item,'sku_id',info.sku_id)
            this.$set(item,'sku_key',info.sku_key)
            this.$set(item,'unit',info.unit)
            if(this.warehouseId){
                let stock_info = info.stocks.find(find => find.id == this.warehouseId)
                if(stock_info){
                    this.$set(item,'stock_info',{
                        code_num:stock_info.code_num,
                        no_code_num:stock_info.no_code_num,
                        total_num:stock_info.total_num,
                    })
                    this.$set(item,'code_num',0)
                    this.$set(item,'no_code_num',0)
                    this.$set(item,'total_num',0)
                }else{
                    this.$set(item,'stock_info',{
                        code_num:0,
                        no_code_num:0,
                        total_num:0
                    })
                    this.$set(item,'code_num',0)
                    this.$set(item,'no_code_num',0)
                    this.$set(item,'total_num',0)
                }
            }
            this.$set(item,'productPopoverShow',false)
        },

        // 选择产品弹窗
        handleClickSelectPopupProduct(item,index){
            this.productInfo = item
            this.productIndex = index
            this.selectProductTransferPopupShow = true
        },
        // 选择完产品回调
        selectProductSuccess(data){
            let json = {
                stock_id:this.warehouseId,
                sku_id:data.sku_id,
                sku_key:data.sku_key,
                name:data.name,
                unit:data.unit,
                stock_info:{
                    code_num:data.code_num,
                    no_code_num:data.no_code_num,
                    total_num:data.total_num,
                },
                code_num:0,
                no_code_num:0,
                total_num:0,
                code_list:[],
                is_edit:true
            }
            this.$set(this.formData.productData,this.productIndex,JSON.parse(JSON.stringify(json)))
        },

        // 头部+号操作
        handleClickHeadOperate(item){
            this.headOperatePopoverShow = false
            if(item.value == 'codeIdentification'){
                this.productInfo = null
                this.selectedCodeData = []
                this.formData.productData.forEach(item =>{
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                })
                this.codeIdentificationPopupShow = true
            }else if(item.value == 'batch_stock'){
                this.productInfo = null
                this.selectStockPopupShow = true
            }
        },
        // 选择产品编码
        handleClickSelectCode(item){
            if(item.name == '')return this.$toast('请先选择产品')
            this.productInfo = item
            this.selectedCodeData = item.code_list
            this.selectCodePopupShow = true
        },

        selectCodeOneSuccess(data){
            this.$set(this.productInfo,'code_list',data)
            this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
            this.$set(this.productInfo,'total_num',Number(this.productInfo.code_num) + Number(this.productInfo.no_code_num))
        },
        // 输入无编码数量
        handleInputNoCodeNum(item){
            this.$nextTick(()=>{
                const num = item.no_code_num;
                const regex = /^[1-9]\d*$/; // 正整数的正则表达式
                if (!regex.test(num)) {
                    this.$set(item,'no_code_num',0)
                } else {
                    // // 如果输入的数量大于总数量则等于总数量
                    if(item.no_code_num > item.stock_info.total_num){
                        this.$set(item,'no_code_num',item.stock_info.total_num)
                    }
                    // // 如果输入的数量大于无编码总数量则等于无编码总数量  并把多余的数量变为有编码的
                    if(item.no_code_num > item.stock_info.no_code_num){
                        let remaining =  item.no_code_num  - item.stock_info.no_code_num // 多余的数量
                        this.$set(item,'no_code_num',item.stock_info.no_code_num)
                        this.automatic_replenishment(item,remaining) //自动补充编码
                    }else{
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                    }

                }
            })
        },
        // 自动补充编码
        automatic_replenishment(row,remaining){
            let postData = {
                page: 1,
                pageSize: remaining + row.code_list.length, // 需要自动选择的编码+已经选择了的编码
                product_name:row.name,
                sku_id:row.sku_id,
                stock_id:this.warehouseId,
                keyword: ''
            }
            chooseCode(postData).then(res => {
                if (res.code === 200) {
                    let {list, total} = res.data
                    // 创建一个包含 code 中现有的集合以便快速查找
                    const existingCodes = new Set(row.code_list.map(item => item.code));
                    // 过滤 list，获取不在 code_list 中的值
                    const filteredList = list.filter(item => !existingCodes.has(item.code));
                    // 从过滤后的列表中添加 'remaining' 个到 code_list中
                    row.code_list.push(...filteredList.slice(0, remaining));
                    this.$set(row,'code_num',row.code_list.length)
                    this.$set(row,'total_num',Number(row.code_num) + Number(row.no_code_num))
                    Dialog.confirm({
                        title: "库存数量已自动补充",
                        message: "此产品无编码数量不足，已为您使用无编码与有编码组合，系统将自动选择有编码产品！",
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                    })
                    .then(() => {})
                    .catch(() => { });
                }
            })
        },
        // 选择仓库
        handleClickSelectStock(item){
            this.selectStockPopupShow = true
        },
        // 选择仓库后回调
        selectStockSuccess(data){
            this.formData.in_stock_id = data.id
            this.formData.in_stock_name = data.name
        },
        // 新增行
        handleClickAdd(){
            let json = {
                stock_id:this.warehouseId,
                sku_id:'',
                sku_key:'',
                name:'',
                unit:'',
                stock_info:{
                    code_num:0,
                    no_code_num:0,
                    total_num:0
                },
                code_num:0,
                no_code_num:0,
                total_num:0,
                code_list:[],
                is_edit:true
            }
            this.formData.productData.push(json)
        },

        handleClickConfirm() {
            if(!this.formData.in_stock_id){
                this.$toast('请选择转入仓库')
                return false
            }
            Dialog.confirm({
                title: "产品转移",
                message: "请仔细核对产品转移，提交后不可撤回。",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {

                let product_list = []
                this.formData.productData.forEach((item)=>{
                    let data = {
                        stock_id: item.stock_id,
                        name: item.name,
                        sku_id: item.sku_id,
                        sku_key: item.sku_key,
                        unit: item.unit,
                        no_code_num: item.no_code_num,
                        code_num: item.code_num,
                        code_list: item.code_list.map(item => item.code),
                        total_num: item.total_num,
                        related_type:"",
                        related_id:0,
                    }
                    if(!data.total_num){
                        this.$toast(`${item.name}数量不可为0`)
                        return false
                    }
                    product_list.push(data)
                })
                if(product_list.length != this.formData.productData.length){
                    return false
                }
                let postData = {
                    product_list:product_list,
                    stock_type: "transfer",
                    in_stock_id:this.formData.in_stock_id,
                    note:this.formData.note
                }
                this.btnDisabled = true
                stockTransfer(postData).then(res=> {
                    if(res.code === 200) {
                        this.$toast({
                            message: res.message,
                            type: "success",
                            duration: 1000,
                            onClose: () => {
                                EventBus.$emit('warehouseUpdated');
                                removeTag(this.$route)
                                this.$router.go(-1);
                                this.btnDisabled = false;
                            },
                        });
                    }else{
                        this.btnDisabled = false
                    }
                })


            })
            .catch(() => { });




        },

    },
};
</script>

<style lang="scss" scoped>
.warehouse_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .warehouse_add_wrap{
        background: #fff;
        .product_list{
            width: 100%;
            padding: 12px 16px;
            box-sizing: border-box;
            ul{
                li{
                    width: 100%;
                    margin-bottom: 10px;
                    border-radius: 6px;
                    background: rgba(247, 248, 250, 1);
                    .product_field{
                        width: 100%;
                        padding: 0 12px;
                        .van-popover__wrapper{
                            flex: 1;
                            display: block;
                        }
                        &.product_border{
                            position: relative;
                            &:before{
                                position: absolute;
                                width: calc(100% - 24px);
                                height: 1px;
                                background: rgba(232, 232, 232, 1);
                                content: " ";
                                left: 12px;
                                bottom: 0;
                                z-index: 9;
                            }
                        }
                        .van-cell{
                            padding-left: 0;
                            padding-right: 0;
                            background: rgba(247, 248, 250, 1);
                        }
                        .field_button{
                            font-size: 14px;
                            padding-left: 8px;
                            color: rgba(41, 144, 255, 1);
                            line-height: 14px;
                            border-left: 1px solid rgba(232, 232, 232, 1);
                        }

                        .bt{
                            padding-top: 10px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            &.required{
                                position: relative;
                                padding-left: 6px;
                                &:before{
                                    position: absolute;
                                    left: 0;
                                    top: 10px;
                                    content: "*";
                                    color: rgba(228, 65, 68, 1);
                                }
                            }
                        }
                        .select_number{
                            width: 100%;
                            .van-cell{
                                width: 78px;
                            }
                            .select_code_box{
                                flex: 1;
                                line-height: 24px;
                                position: relative;
                                .select_btn{
                                    font-size: 14px;
                                    color: rgba(41, 144, 255, 1);
                                }
                                .total_num{
                                    border-radius: 4px;
                                    background: rgba(255, 255, 255, 1);
                                    min-width: 22px;
                                    padding: 0 4px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }

                    }
                }
            }
            .product_add{
                text-align: center;
                line-height: 22px;
                span{
                    color: rgba(25, 144, 255, 1);
                    i{
                        font-size: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .field_item{
            width: 100%;
            border-top: 1px solid rgba(247, 248, 250, 1);
            padding: 10px 16px;
            box-sizing: border-box;
            .field_name{
                width: 100%;
                line-height: 22px;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 4px;
            }
            .field_content{
                width: 100%;
                .van-cell{
                    padding:0 0 4px 0;
                    &.van-cell--required::before{
                        position: static;
                        margin-right: 2px;
                    }
                }
                .file_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            margin-bottom: 10px;
                            border-radius: 2px;
                            background: rgba(249, 249, 249, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            line-height: 20px;
                            padding: 0 8px;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                width: calc(100% - 50px);
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);
                            }
                            div{
                                width: 48px;
                                span{
                                    width: 16px;
                                    margin-left: 8px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                                i{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                }
                            }
                        }
                    }
                }
                .file_note{
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 18px;
                    margin-bottom: 34px;
                }
                .file_upload{
                    width: 100px;
                    position: relative;
                    line-height: 22px;
                    margin: 0 auto;
                    color: rgba(25, 144, 255, 1);
                    font-size: 14px;
                    text-align: center;
                    i{
                        margin-right: 8px;
                    }
                    input{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                }

            }
        }
    }
}
.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}

::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
    display: none !important;
}

.productItemBox{
    width: calc(100vw - 56px);
    padding: 8px 2px;
    box-sizing: border-box;
    max-height: 220px;
    overflow-y: auto;
    .product_item{
        width: 100%;
        line-height: 30px;
        padding: 0 12px;
        color: rgba(102, 102, 102, 1);
        &:active{
            color: rgba(102, 102, 102, 1);
            background: rgba(0, 0, 0, 0.04);
        }
        .product_name {
            display: block;
            width: calc(100% - 50px);
        }
        .product_tag {
            width: 40px;
            height: 22px;
            opacity: 1;
            border-radius: 4px;
            background: rgba(240, 170, 50, 0.1);
            line-height: 22px;
            font-size: 12px;
            color: rgba(240, 170, 50, 1);
            text-align: center;
        }
    }

}
</style>
